<script>
import BaseListing from './Listing'

export default {
  mixins: [
    BaseListing
  ],
  data () {
    return {
      headerTitle: { title: 'Role:', description: 'Lista' },
      service: this.$route.meta.acl.service,
      actionShowUrlName: '',
      gridName: 'grid_role'
    }
  },
  created () {
    this.getInitActionShowUrlName()
  },
  methods: {
    getInitActionShowUrlName () {
      this.actionShowUrlName = `${this.service}_role_details`
    }
  }
}
</script>
